import { render, staticRenderFns } from "./ObjectGrid.vue?vue&type=template&id=0d7aa802"
import script from "./ObjectGrid.vue?vue&type=script&lang=js"
export * from "./ObjectGrid.vue?vue&type=script&lang=js"
import style0 from "./ObjectGrid.vue?vue&type=style&index=0&id=0d7aa802&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports